import { forwardRef } from "react";
import { Menu } from '@material-ui/core';

export default forwardRef((props, ref) =>
  <Menu ref={ref} {...props} />);